import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { VALUE_PROP_ACCENT_STYLES } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ValuePropItem = ({
  valueProp,
  index,
  isActive,
  isHighlighted,
  onClick,
  onMouseEnter,
  onMouseLeave
}) => {
  const Icon = valueProp.icon;
  const iconStyle = VALUE_PROP_ACCENT_STYLES[index];
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "200",
    padding: "200",
    marginBlockEnd: "600",
    borderRadius: "100",
    borderInlineStartStyle: "solid",
    borderInlineStartWidth: "300",
    borderInlineStartColor: isHighlighted ? 'border-core-pressed' : 'fill-transparent-default',
    backgroundColor: isHighlighted ? 'fill-surface-recessed' : undefined,
    role: "button",
    tabIndex: 0,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    children: [/*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "full",
      backgroundColor: isActive ? 'fill-secondary-default' : iconStyle.iconBackground,
      borderWidth: isActive ? '100' : '0',
      borderColor: isActive ? iconStyle.iconBorderColor : undefined,
      minInlineSize: "36px",
      minBlockSize: "36px",
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(Icon, {
        size: "300",
        color: isActive ? iconStyle.iconColor : 'icon-core-default'
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "span",
      children: isActive ? /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: valueProp.titleKey
        })
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: valueProp.titleKey
      })
    })]
  });
};
export default ValuePropItem;